<template>
  <div class="g">
    <Top>
      <div class="g_ctn">
        <div class="g_opt">
          <div class="get" @click="handleRefrsh">
            <div class="circular">
              <span class="iconfont icon-yunduanshuaxin" />
            </div>
            <span class="text">读取分组</span>
          </div>
          <div class="get" @click="handleSet">
            <div class="circular">
              <span class="iconfont icon-shezhi" />
            </div>
            <span class="text">保存分组</span>
          </div>
        </div>
      </div>

      <!-- 水泵类型的设备阀门 -->
      <div class="group">
        <!-- 选择程序 -->
        <div class="choose-program">
          <div class="name">选择程序</div>
          <div class="sel" @click="handlePickerProgram">
            <span v-show="defaultProgram"
              >{{ defaultProgram && defaultProgram.index + 1 }}号程序</span
            >
            <span v-show="!defaultProgram">未读取到程序</span>
            <span class="iconfont icon-xiala"></span>
          </div>
        </div>
        <div class="item card" v-for="(item, index) in pumpGroups" :key="index">
          <div class="row1">
            <div class="r_t">
              <span class="cir">
                <span v-if="index === 0" class="iconfont icon-shuibeng"></span>
                <span v-else class="iconfont icon-shifei"></span>
              </span>
              <span class="name">{{ item.groupName }}</span>
            </div>
            <div class="r_b" v-if="item.valveList.length">
              <van-field
                class="inp"
                type="number"
                v-for="(valve, valIndex) in item.valveList"
                :key="valIndex"
                :value="valve"
                @click="handleChangeValve(index, index, valIndex, 'machine')"
              />
            </div>
          </div>
          <div class="row2"></div>
        </div>
      </div>

      <!-- 分组阀门 -->
      <div class="group valveGroup">
        <div
          class="item card"
          v-for="(item, index) in valveGroups"
          :key="index"
        >
          <div class="row1">
            <div class="r_t">
              <div class="r_t_l">
                <span class="cir">
                  <span class="iconfont icon-shenghuoshuibengfang"></span>
                </span>
                <span class="name">
                  {{ item.groupName }}
                  <!-- <van-field type="text" v-model="item.groupName" /> -->
                </span>
              </div>

              <div class="r_t_r">
                <span class="tx">时长</span>
                <span>
                  <van-field
                    :disabled="item.requiredManureDrill"
                    class="inp"
                    type="number"
                    maxlength="4"
                    v-model="item.min"
                  />
                </span>
                <span class="tx">分钟</span>
              </div>
            </div>
            <div>
              <div class="txt" v-show="false">增减阀门</div>
              <div class="r_b">
                <div class="r_b_l">
                  <van-field
                    class="inp"
                    type="number"
                    v-for="(valve, valIndex) in item.valveList"
                    :key="valIndex"
                    :value="valve"
                    @click="handleChangeValve(3, index, valIndex, 'group')"
                  />
                </div>
              </div>
            </div>

            <!-- 施肥机 -->
            <div class="shifeiji">
              <div class="row">
                <span class="title">
                  <span class="icon"><i class="iconfont icon-shifei"/></span>
                  <span class="tit">需要施肥机</span>
                </span>
                <van-switch
                  size="22px"
                  v-model="item.requiredManureDrill"
                  maxlength="4"
                  @change="val => handleSwitch(val, item, index)"
                  active-color="#3B6BE0"
                  inactive-color="#dcdee0"
                  :active-value="true"
                  :inactive-value="false"
                />
              </div>
              <div class="row">
                <div class="time">
                  预充&nbsp;
                  <van-field
                    v-model="item.preTime"
                    :disabled="!item.requiredManureDrill"
                    class="inp"
                    maxlength="3"
                    type="number"
                    @change="e => handleChangeTime(e, item, index)"
                  />&nbsp; 分钟
                </div>
                <div class="time">
                  施肥&nbsp;
                  <van-field
                    v-model="item.manureTime"
                    :disabled="!item.requiredManureDrill"
                    class="inp"
                    maxlength="3"
                    type="number"
                    @change="e => handleChangeTime(e, item, index)"
                  />&nbsp; 分钟
                </div>
                <div class="time">
                  冲洗&nbsp;
                  <van-field
                    v-model="item.washTime"
                    :disabled="!item.requiredManureDrill"
                    class="inp"
                    maxlength="3"
                    type="number"
                    @change="e => handleChangeTime(e, item, index)"
                  />&nbsp; 分钟
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <van-popup
        v-model="visible"
        position="bottom"
        :style="{ width: '100%', height: '6.8rem' }"
      >
        <van-picker
          title="选择阀门"
          show-toolbar
          :columns="clickType === 'group' ? options : machineOptions"
          @confirm="onConfirm"
          @cancel="onCancel"
        />
      </van-popup>
      <van-popup v-model="showChooseProgram" position="bottom">
        <van-picker
          title="选择程序"
          show-toolbar
          :columns="programList"
          value-key="programName"
          @confirm="onProConfirm"
          @cancel="onProCancel"
        />
      </van-popup>
    </Top>
  </div>
</template>

<script>
import Top from "@/views/lunGuan/top.vue";

export default {
  components: {
    Top
  },

  data() {
    return {
      programList: [], // 程序列表
      defaultProgram: null, // 之前选中的程序号
      pumpGroups: [
        {
          key: "pumpGroup",
          groupName: "水泵",
          valveList: ["", "", "", "", "", "", ""]
        },
        {
          key: "manureDrill",
          groupName: "施肥机",
          valveList: ["", "", "", "", "", "", ""]
        }
      ],
      valveGroups: [],
      options: [],
      machineOptions: [],
      irrigationInfo: {},
      visible: false,
      optionsType: null, // 1 网关阀门（水泵）   2 RTU阀门（分组）
      deviceIndex: null, // 网关阀门的下标
      valveIndex: null, // 分组阀门的下标
      no: "",
      programInfo: null,
      showChooseProgram: false,
      clickType: null, // 点击的是分组阀门('group')还是水泵施肥的阀门('machine')
      type: null
    };
  },
  async mounted() {
    const no = localStorage.getItem("no");
    this.type = sessionStorage.getItem("deviceType");
    this.no = no;
    const arr = [];
    const arr2 = [];

    const type = sessionStorage.getItem("deviceType");
    // 13 是128位控制器  14 是32位
    let num = 256;

    for (let i = 0; i < num; i++) {
      arr2.push(i);
      arr.push(i);
    }
    this.machineOptions = [...arr2];
    this.options = [...arr];

    await this.$toast.loading({
      message: "加载中...",
      forbidClick: true,
      duration: 0
    });

    // 先读取程序列表
    await this.getProgramList();
    await this.getDefaultProgram();
  },

  methods: {
    // 读取程序列表
    async getProgramList() {
      await this.$api.lgV3_getProgram_list(this.no).then(res => {
        if (res.errcode === 0) {
          const data = res.data;
          data.map(item => {
            item.programName = String(item.index + 1) + "号程序";
          });
          this.programList = [...data];
        } else {
          this.$toast.clear();
          this.$toast({
            message: "查询程序列表异常:" + res.errmsg
          });
        }
      });
    },

    async getDefaultProgram() {
      const defaultProgram = sessionStorage.getItem("LUNGUAN_DEFAULT_PROGRAM");
      // 默认的程序
      if (defaultProgram) {
        this.defaultProgram = JSON.parse(defaultProgram);
      } else if (this.programList.length) {
        this.defaultProgram = this.programList.find(o => o.index === 0);
      } else {
        this.defaultProgram = null;
      }
      // 根据默认的程序读取程序的状态
      await this.getGroup();

      setTimeout(() => {
        this.$toast.clear();
      }, 10);
    },

    async getGroup() {
      const fn = "lgV4_getGroup";
      await this.$api[fn]({
        gatewayNo: this.no,
        proId: this.defaultProgram.index
      }).then(res => {
        try {
          if (res.errcode !== 0) return this.$toast(res.errmsg);
          if (res.data) {
            const {
              pumpGroup,
              valveGroups = [],
              manureDrill,
              irrigationInfo
            } = res.data;
            this.irrigationInfo = { ...(irrigationInfo ?? {}) };
            const pumpGroupsList = [...this.pumpGroups];
            pumpGroupsList[0].valveList = [...pumpGroup.valveList];
            pumpGroupsList[1].valveList = [...manureDrill.valveList];
            valveGroups.map((item, i) => {
              item.groupName = `第${i + 1}组`;
              if (item.totalTime) item.min = item.totalTime / 60;
              if (!item.groupName) item.groupName = `第${i + 1}组`;
              if (item.preTime) item.preTime = item.preTime / 60;
              if (item.manureTime) item.manureTime = item.manureTime / 60;
              if (item.washTime) item.washTime = item.washTime / 60;
            });
            this.valveGroups = [...valveGroups];
            this.pumpGroups = [...pumpGroupsList];


            console.log("  this.valveGroups:" ,  this.valveGroups);

          }
        } catch (e) {
          console.error("e:", e);
        }
      });
    },

    // 读取分组
    async handleRefrsh() {
      await this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      });
      this.getDefaultProgram();
    },

    // 切换阀门编号 需要注意是设备的阀门还是分组的阀门
    onConfirm(data) {
      if (this.optionsType < 2) {
        this.pumpGroups[this.optionsType].valveList[this.valveIndex] = data;
      } else {
        this.valveGroups[this.deviceIndex].valveList[this.valveIndex] = data;
      }
      this.onCancel();
    },

    onCancel() {
      this.visible = false;
      this.optionsType = null;
      this.deviceIndex = null;
      this.valveIndex = null;
    },

    // 修改阀门 1-32
    handleChangeValve(type, deviceIndex, valveIndex, clickType) {
      this.optionsType = type;
      this.deviceIndex = deviceIndex;
      this.valveIndex = valveIndex;
      this.visible = true;
      this.clickType = clickType;
    },

    // 减阀门
    handleReduce(index) {
      if (this.valveGroups[index].valveList.length) {
        this.valveGroups[index].valveList.pop();
      } else {
        this.$toast.fail("没有阀门");
      }
    },
    // 加阀门
    handleAdd(index) {
      if (!this.valveGroups[index] || !this.valveGroups[index].valveList) {
        const tar = { ...this.valveGroups[index] };

        this.$set(this.valveGroups, index, {
          ...this.valveGroups[index],
          valveList: []
        });
      }

      if (this.valveGroups[index].valveList.length < 12) {
        this.valveGroups[index].valveList.push(0);
      } else {
        this.$toast.fail("最多执行12个阀门");
      }
    },

    handlePickerProgram() {
      this.showChooseProgram = true;
    },

    async onProConfirm(val) {
      sessionStorage.setItem("LUNGUAN_DEFAULT_PROGRAM", JSON.stringify(val));
      this.showChooseProgram = false;
      console.time();
      await this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      });
      await this.getDefaultProgram();
      console.timeEnd();
    },

    onProCancel() {
      this.showChooseProgram = false;
    },

    // 是否需要施肥机
    handleSwitch(val, data, index) {
      if (val) {
        // 开启 三者的时间相加 = 总时长
        data.min = this.coculatMin(data);
      } else {
        // 关闭  重置总时长
        data.min = 0;
        data.preTime = 0;
        data.manureTime = 0;
        data.washTime = 0;
      }
      this.$set(this.valveGroups, index, data);
    },

    // 修改施肥机的三个时间
    handleChangeTime(val, data, index) {
      if (data.requiredManureDrill) {
        data.min = this.coculatMin(data);
        data.totalTime = data.min * 60;
      }
      console.log("data:", data);
      this.$set(this.valveGroups, index, data);
    },

    coculatMin(data) {
      return (
        (Number(data.preTime) || 0) +
        (Number(data.manureTime) || 0) +
        (Number(data.washTime) || 0)
      );
    },

    // 设置分组
    async handleSet() {
      await this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0
      });

      const valveGroups = JSON.parse(JSON.stringify(this.valveGroups));

      // 查询所有程序的执行状态 如果自身的程序还在执行中 无法保存分组
      const _res = await this.$api.lgV3_getProgram_list(this.no);
      if (_res.errcode === 0) {
        const data = _res.data;
        const find = data.find(
          o => o.index == this.defaultProgram.index && o.sta === 1
        );
        if (find) {
          return this.$toast({
            message: `程序${this.defaultProgram.index +
              1}正在执行中，无法设置分组`,
            duration: 2000
          });
        }
      }

      // 校验阀门组
      const find = valveGroups.find(
        o => o.requiredManureDrill && o.valveList.every(o => o == 0)
      );
      const find2 = valveGroups.find(
        o => o.requiredManureDrill && !o.totalTime
      );
      const find3 = valveGroups.find(
        o => o.totalTime && o.valveList.every(o => o == 0)
      );
      console.log("find1:", find);
      console.log("find2:", find2);
      console.log("find3:", find3);
      console.log("valveGroups:", valveGroups);

      if (find)
        return this.$toast({
          message: `${find.groupName}开启了施肥机，阀门不能为空`
        });
      if (find2)
        return this.$toast({
          message: `${find2.groupName}开启了施肥机，总时长不能为空`
        });
      if (find3)
        return this.$toast({
          message: `${find3.groupName}设置了总时长，阀门不能为空`
        });

      // 校验 预充 施肥 冲洗 时间不能超过255分钟 总时长不能大于 1080分钟
      const errTip = [];

      valveGroups.map((o, i) => {
        if (o.min) {
          o.totalTime = o.min * 60;
        } else {
          o.totalTime = 0;
        }

        o.preTime = (Number(o.preTime) || 0) * 60;
        o.manureTime = (Number(o.manureTime) || 0) * 60;
        o.washTime = (Number(o.washTime) || 0) * 60;

        let errMsg = `第${i + 1}组`;
        let hasErr = false;

        if (o.totalTime > 1080 * 60) {
          hasErr = true;
          errMsg += "总时长不能大于1080";
        }
        if (o.preTime > 255 * 60) {
          hasErr = true;
          errMsg += ",预充时长不能大于255";
        }
        if (o.manureTime > 255 * 60) {
          hasErr = true;
          errMsg += ",施肥时长不能大于255";
        }
        if (o.washTime > 255 * 60) {
          hasErr = true;
          errMsg += ",冲洗时长不能大于255";
        }

        hasErr && errTip.push(errMsg);

        delete o.min;
        return o;
      });

      if (errTip.length) {
        return this.$toast({
          message: errTip.join("\n"),
          duration: 5000
        });
      }

      const param = {
        gatewayNo: this.no,
        proId: this.defaultProgram.index,
        pumpGroup: {
          groupName: "水泵",
          valveList: this.pumpGroups[0].valveList
        },
        manureDrill: {
          groupName: "施肥机",
          valveList: this.pumpGroups[1].valveList
        },
        valveGroups,
        irrigationInfo: { ...this.irrigationInfo }
      };

      setTimeout(async () => {
        const fn = "lgV4_setGroup";
        await this.$api[fn](param).then(res => {
          if (res.errcode !== 0) return this.$toast(res.errmsg);
          this.$toast.success("设置成功");
        });

        setTimeout(() => {
          this.$toast.clear();
        }, 1500);
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
.g {
  background: rgba(241, 247, 255, 1) !important;
}

.g_ctn {
  margin-bottom: 10px;
}

.g_opt {
  display: flex;
  align-items: center;
  height: 55px;
  padding: 18px 28px;
  background: #ffffff;
}

.get {
  display: flex;
  flex: 1;
  align-items: center;
  // justify-content: center;

  &:first-child {
    border-right: 0.5px solid rgba(232, 232, 232, 1);
  }

  &:last-child {
    justify-content: flex-end;
  }

  .text {
    font-size: 16px;
    margin-left: 11px;
  }

  .circular {
    width: 39px;
    height: 39px;
    background: linear-gradient(
      90deg,
      rgba(72, 119, 233, 1) 0%,
      rgba(25, 76, 201, 1) 100%
    );

    border-radius: 50%;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .icon-yunduanshuaxin,
  .icon-shezhi {
    font-size: 24px !important;
  }
}

.choose-program {
  display: flex;
  align-self: start;
  justify-content: space-between;
  padding: 12px 6px;
  font-size: 18px;
  border-bottom: 0.5px solid #e8e8e8;
  background: #ffffff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  .name {
    color: #333333;
  }

  .sel {
    display: flex;
    align-items: center;
    color: #979797;
  }
}

.card {
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  padding: 10px 7px;
  margin-bottom: 12px;

  .row1 {
    font-size: 14px;

    // .name{
    //   margin-left: 16px;
    // }

    .r_t {
      display: flex;
      align-items: center;
      margin-bottom: 13px;
    }

    .txt {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 8px;
      padding-right: 10px;
    }

    .r_b {
      display: flex;
      margin: 6px;

      .r_b_l {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
      }

      .inp {
        width: 48px;
        height: 35px;
        border: 0.5px solid rgba(151, 151, 151, 1);
        border-radius: 4px;
        margin-right: 7px;
        margin-bottom: 6px;
        padding: 10px;

        ::v-deep input {
          text-align: center !important;
        }
      }

      .cir {
        width: 26px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        font-size: 24px;
        color: #ffffff;
        border-radius: 50%;
      }

      .reduce {
        background: rgba(214, 218, 221, 1);
        box-shadow: 0px 2px 2px rgba(229, 229, 229, 1);
      }

      .add {
        background: rgba(53, 102, 220, 1);
        box-shadow: 0px 2px 2px rgba(49, 171, 254, 0.2);
      }

      .value {
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
        margin: 0 9px;
      }

      .btn {
        display: flex;
        align-items: center;
      }
    }

    .icon-shuibeng {
      font-size: 25px;
    }

    .cir {
      display: block;
      width: 32px;
      height: 32px;
      line-height: 32px;
      border-radius: 50%;
      background: rgba(59, 107, 224, 1);
      color: #ffffff;
      text-align: center;
    }

    .name {
      font-size: 16px;
      margin-left: 16px;
    }
  }
}

.valveGroup {
  .r_t {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(232, 232, 232, 1);
    padding-bottom: 9px;
  }

  .r_t_l {
    display: flex;
    align-items: center;
    flex: 1;
  }

  .r_t_r {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;
    color: rgba(151, 151, 151, 1);

    .inp {
      width: 60px;
      height: 31px;
      background: rgba(248, 248, 248, 1);
      border-radius: 4px;
      ::v-deep input {
        text-align: center !important;
      }
    }

    .tx {
      margin: 0 5px;
    }
  }
}

.shifeiji {
  width: 100%;
  padding: 12px 15px;
  background: #f5f7fb;
  border-radius: 8px;
  box-sizing: border-box;

  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .title {
    display: flex;
    align-items: center;

    .icon {
      display: inline-block;
      width: 24px;
      height: 24px;
      line-height: 24px;
      border-radius: 50%;
      text-align: center;
      background: #3b6be0;

      i {
        color: #ffffff;
        font-size: 12px;
      }
    }

    .tit {
      margin-left: 4px;
    }
  }

  .time {
    display: flex;
    align-items: center;
    margin-top: 10px;
    font-size: 12px;
    color: #979797;

    .inp {
      width: 40px;
      padding: 4px 0;
      border: 0.5px solid #979797;
      border-radius: 4px;
      text-align: center;
      margin: 0 2px;
      font-size: 14px;
    }

    ::v-deep .van-field__control {
      text-align: center;
    }
  }
}
</style>
